export default __webpack_public_path__ + "src/img//the-loopa.svg";